<div class="todo-container">
  <div class="cards">
    <div class="add-card-container">
      <button (click)="addCard()">
        Add New Event
        <span>+</span>
      </button>
    </div>
    @for (card of cards; track $index) {
      <app-card [card]="card"></app-card>
    }
  </div>
  @if (errorMessages) {
    <div class="error-messages">
      <p>{{ errorMessages }}</p>
    </div>
  }
</div>
